module.exports = __webpack_public_path__ + "static/media/ils_covid_failed_fisdom.979a8c34.svg";